<h2 mat-dialog-title>
  Os veículos listados abaixo não estão autorizados a circular nas data informadas e <br>
  entre os  horários restritos (7h–10h e 17h–20h) conforme regra de rodízio de veículos.</h2>
<mat-dialog-content>
  <rot-list-paginator
    [columns]="colunasGrid"
    [exibirSelecao]="false"
    [dados]="dados"
    [utilizaPaginacao]="false">
  </rot-list-paginator>
</mat-dialog-content>
<mat-dialog-actions class="card-actions-button-dialog-pesquisa">
  <button
    (click)="fechar()"
    mat-raised-button
    color="warn"
    mat-dialog-close>
    <em class="la la-times"></em>
    Fechar
  </button>
</mat-dialog-actions>
